import ItemActividadResumenItemProps from "./ItemActividadResumenItemProps";

export default class ItemActividadResumenItem {
    title: string;
    props: ItemActividadResumenItemProps;

    constructor(title: string, props: ItemActividadResumenItemProps) {
        this.title = title;
        this.props = props;
    };
};
